var map = {
	"./bg_03.jpg": "34d7",
	"./body_bg - 副本.jpg": "a76a",
	"./body_bg-back2.jpg": "9fd8",
	"./body_bg.jpg": "95aa",
	"./body_bg2 - 副本.jpg": "00dc",
	"./body_bg2.jpg": "b7e8",
	"./cjwt1.jpg": "47e1",
	"./cjwt2.jpg": "0549",
	"./classroom_1.jpg": "65f5",
	"./classroom_2.jpg": "686d",
	"./classroom_3.jpg": "2564",
	"./classroom_4.jpg": "f80f",
	"./dzfp.jpg": "4ee8",
	"./example1.jpg": "90fd",
	"./example2.jpg": "4aa6",
	"./example3.jpg": "ae62",
	"./example4.jpg": "9edb",
	"./example5.jpg": "fd8c",
	"./example6.jpg": "6913",
	"./guanbi.jpg": "cf03",
	"./jp4_01.jpg": "8acd",
	"./left-back.jpg": "c6e3",
	"./tiao.jpg": "6605",
	"./tiaozhuan.jpg": "2f0d"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "9853";